mainDefinition